import { isServerRendering } from 'src/app/utils/environment';

const extractUivIfPopulated = (uiv: string[]): string | undefined =>
  // one key param, AND not an empty string, pass it, else undefined
  uiv.length === 1 && uiv[0].length ? uiv[0] : undefined;

export const getUivQueryParam = (): string | undefined => {
  if (isServerRendering()) {
    return undefined;
  }

  const parsed = new URLSearchParams(window.location.search);
  const v = parsed.getAll('v');
  const V = parsed.getAll('V');

  return extractUivIfPopulated(v) ?? extractUivIfPopulated(V);
};
